import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import dataReducer from './getApiData/reducer'
import submitReducer from './submitData/reducer'
import embedConfigReducer from './getEmbedConfig/reducer'
import secretsReducer from './getSecrets/reducer';
import getUserPermissionReducer from './getUserPermission/reducer'
import updateUserPermissionReducer from './updateUserPermission/reducer'

export const store = configureStore({
  reducer: {
    apiData: dataReducer,
    submitData: submitReducer,
    embedConfig: embedConfigReducer,
    secrets: secretsReducer,
    userPermissionData: getUserPermissionReducer,
    submitUserPermissionData: updateUserPermissionReducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
